import { axiosApi } from '../constants/axios_api';
import appUrl from '../constants/appUrl';

export default async function loadRolePermissions(user) {
    const items = (user?.menu || []).flatMap(group => group.items || []);
    if (!user?.role?._id) return [];
    return Promise.all(items.filter(item => item._id && item.to).map(async item => {
        const { data } = await axiosApi.get(appUrl.baseUrl + appUrl.roleModulePermission, {
            params: { roleId: user.role._id, subModuleId: item._id },
        });
        return { path: item.to, permissions: data?.data?.permissions || { view: false, edit: false, add: false, delete: false } };
    }));
}
